import { render, staticRenderFns } from "./ValidationAlertByValidator.vue?vue&type=template&id=1265d053&scoped=true&lang=pug"
import script from "./ValidationAlertByValidator.vue?vue&type=script&lang=ts"
export * from "./ValidationAlertByValidator.vue?vue&type=script&lang=ts"
import style0 from "./ValidationAlertByValidator.vue?vue&type=style&index=0&id=1265d053&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1265d053",
  null
  
)

export default component.exports